<template>
  <div>
    <span>
      <b-button v-on:click="detail()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetail"
          width="20"
          height="20"
          :color="params.iconColor"
          v-b-tooltip.hover.bottom="$t(params.tooltip)"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: ["detailMethods", "iconDetail", "iconColor", "tooltip"],
  components: { Icon },
  methods: {
    detail() {
      this.$root.$emit(this.params.detailMethods, this.params.data);
    },
  },
};
</script>
